import './H_Spacer.css';

function H_Spacer({ style }) {
    return (
        <div className='H_Spacer' style={style}></div>
    );
}

export default H_Spacer;
